import { handleActions } from 'redux-actions';
import * as actions from './actions';
import { resetForm } from "../create-llama/actions";

const defaultState = {
  originPhotoPath: null,
  resultPhotoPath: null,
  originPhotoInfo: null,
  resultPhotoInfo: null,
  layoutSize: null
};

const reducer = handleActions(
  new Map([
    [actions.setOriginPhoto,
      (state, action: any) => {
        const { uri, ...other } = action.payload || { uri: null };
        return {
          ...state,
          originPhotoPath: uri,
          originPhotoInfo: other
        }
      }],
    [actions.setResultPhoto,
      (state, action) => {
        const { uri, ...other } = action.payload || { uri: null };
        return {
          ...state,
          resultPhotoPath: uri,
          resultPhotoInfo: other
        }
      }],
    [actions.setLayoutSize,
      (state, action) => ({ ...state, layoutSize: action.payload })],
    // reset
    [resetForm, (state, action) => {
      return { ...defaultState };
    }],
    [actions.restorePhoto, (state, action) =>  action.payload]
  ]),
  defaultState
);

export default reducer;